import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { QueryNames } from 'Hooks/api/queryNames'
import { AppNotification } from 'Utils/types/appNotification'
import { forceTransactionAccountUpdateMode } from 'Services/JOONAdmin/joonAdminUsersService'

export const useForceUpdateModeQuery = (userId: number) => {
  const queryClient = useQueryClient()

  return useMutation(
    [QueryNames.ForceUpdateMode],
    (transactionAccountId: number) =>
      forceTransactionAccountUpdateMode(userId, transactionAccountId),
    {
      onSuccess: (response) => {
        if (response.success) {
          toast.success(AppNotification.ForceUpdateModeSuccess)
        } else {
          toast.error(`${AppNotification.ForceUpdateModeFailure} ${response.message}`)
        }
      },
      onError: () => {
        toast.error(`${AppNotification.ForceUpdateModeFailure}`)
      },
      onSettled: () => {
        queryClient.invalidateQueries([QueryNames.GetAdminAccountDetails, userId])
      }
    }
  )
}
